module.exports = __webpack_public_path__ + "img/wallet-logo.d09aa7f2.png";